<template>
  <div>
    <Header />
    <main class="main">

      <div class="confirm-wrapper">
        <div class="wrap">
          <ol>
            <li>Open this page <a href="https://www.jeepgrilles.co.nz" target="_blank">(Jeep Competition)</a> on your mobile device and click the following link to add our official camera app to your home screen.</li>
            <li>Use the app to take a photo or choose one from your camera roll, then select a Jeep Grille to match your mood and overlay it on your photo – the more creative, the better! When you’re ready, click submit.</li>
            <li>Your creation will also be saved to your photos, be sure to post it to your Facebook or Instagram with the hashtag <strong>#JEEPCOMP</strong> to be eligible for the competition.</li>
            <li>Once that’s done, we’ll add your creation to our public gallery. The winner will be chosen by Jeep NZ as the “most creative” and wins a brand new <strong>Jeep Renegade Longitude</strong> vehicle. <br/><br/>Entries close 31/12/18. Click here for full <router-link to="/page/terms">Terms & Conditions.</router-link></li>
          </ol>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'instructions',
  components: {Header},
  data () {
    return {
    }
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    min-height: auto;
    margin: 0;
    text-align: left;
  }

  .confirm-wrapper {
    padding: 80px 6%;
    background: #1f1f1f;

    .wrap {
      max-width: 610px;
      margin: auto;
    }

    p, li {
      position: relative;
      margin-bottom: 54px;
      padding: 0 0 0 20px;
      font-size: 18px;
      font-weight: 600;
      color: white;

      @media (min-width: $medium) {
        padding: 0;
      }

      strong, a {
        color: $color-1a;
      }
    }

    ol {
      counter-reset: my-awesome-counter;
      list-style: none;
    }

    ol li {
      counter-increment: my-awesome-counter;
    }

    ol li::before {
      content: counter(my-awesome-counter);
      position: absolute;
      top: 0;
      left: -20px;
      width: 30px;
      height: 30px;
      font-size: 22px;
      font-weight: bold;
      line-height: 28px;
      text-align: center;
      color: $color-1a;
      border: 2px solid $color-1a;
      border-radius: 50%;

      @media (min-width: $medium) {
        left: -90px;
        width: 50px;
        height: 50px;
        font-size: 32px;
        line-height: 45px;
      }
    }
  }

</style>
